import { Text, Image } from "@chakra-ui/react";
import Brand from "../../Assets/brand-big.png";

export function Logo() {
  return <Image src={Brand} alt="Brand" w="10%" />;
}
